/* DACKO video: starts the muted video once its band nears the viewport, so the file is not
   fetched at page load, and leaves it paused under reduced motion. The toggle is the pause
   control WCAG 2.2.2 requires; its label follows the video's own play and pause events.
   Re-inits on shopify:section:load for the Theme Editor. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initVideo(root) {
    if (root.dataset.dackoVideoInit) return; // guard against double-binding
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-dacko-video-toggle]');
    if (!video || !toggle) return;
    root.dataset.dackoVideoInit = '1';

    const sync = () => {
      const playing = !video.paused;
      toggle.dataset.state = playing ? 'playing' : 'paused';
      toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
    };
    // A refused play() (iOS Low Power Mode) leaves the video paused and the Play label showing
    const play = () => video.play().catch(sync);

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    toggle.addEventListener('click', () => (video.paused ? play() : video.pause()));
    toggle.hidden = false;
    sync();

    if (reduceMotion.matches) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        play();
      },
      { rootMargin: '200px 0px' }
    );
    observer.observe(root);
  }

  const initAll = (scope) => (scope || document).querySelectorAll('[data-dacko-video]').forEach(initVideo);

  initAll(); // `defer` guarantees the DOM is parsed
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
